import { useFpB2bCartService } from '@cart-services/hooks/fp-b2b/use-fp-b2b-cart-service'
import { useFpB2bCoupons } from '@cart-services/hooks/fp-b2b/use-fp-b2b-coupons'
import { useFpB2bProductCatalogProducts } from '@cart-services/hooks/fp-b2b/use-fp-b2b-product-catalog-products'
import { type MergedCouponMap } from '@cart-services/types'
import { Paper } from '@pets-ui/Paper/Paper'
import { VStack } from '@pets-ui/VStack/VStack'
import { useMemo } from 'react'
import { useProductCatalog } from '../../../fp-b2b-shared/hooks/use-product-catalog'
import { useStmCouponFilter } from '../hooks/use-stm-coupon-filter'
import { CouponFilterBar } from './CouponFilterBar'
import { StmCollapseProduct } from './StmCollapseProduct'

const EMPTY_COUPON_MAP: MergedCouponMap = new Map()

interface StmCategoryProductsProps {
  category: string
}

export const StmCategoryProducts = ({ category }: StmCategoryProductsProps) => {
  const { campaignId, projectCode, countryCode, campaignCode, platform } = useProductCatalog()
  const { productCatalogDto } = useFpB2bProductCatalogProducts(campaignId, projectCode, campaignCode, platform)
  const { mergedCouponMap = EMPTY_COUPON_MAP, getMergedCouponCriterions } = useFpB2bCoupons(campaignId, projectCode, countryCode, campaignCode, platform)
  const { items: cartItems } = useFpB2bCartService(campaignId, platform)

  const currentCategory = useMemo(
    () => productCatalogDto?.products.find(p => p.tab_display_name === category),
    [productCatalogDto?.products, category],
  )

  const tabCouponIds = useMemo(() => currentCategory?.coupon_ids ?? [], [currentCategory?.coupon_ids])
  const tabProducts = currentCategory?.all_product

  const {
    tabCoupons,
    selectedCouponIds,
    toggleCoupon,
    selectAllTabCoupons,
    deselectAllCoupons,
    filteredProducts,
  } = useStmCouponFilter({ tabCouponIds, mergedCouponMap, tabProducts })

  return (
    <VStack gap={6}>
      <Paper borderRadius={8} p={3} elevation={0}>
        <CouponFilterBar
          tabCoupons={tabCoupons}
          selectedCouponIds={selectedCouponIds}
          toggleCoupon={toggleCoupon}
          selectAllTabCoupons={selectAllTabCoupons}
          deselectAllCoupons={deselectAllCoupons}
        />
      </Paper>
      <VStack gap={4}>
        {filteredProducts.map(product => (
          <Paper key={product.id} borderRadius={8} p={3} elevation={0}>
            <StmCollapseProduct
              parentProductGroup={product}
              projectCode={projectCode}
              cartItems={cartItems}
              getMergedCouponCriterions={getMergedCouponCriterions}
            />
          </Paper>
        ))}
      </VStack>
    </VStack>
  )
}
